@import '../../style/index';

@include host {
  margin: rem-calc(-48px) 0;

  @include large-up {
    margin: rem-calc(-80px) 0;
  }
}
